import React, { Dispatch, SetStateAction, createContext, useEffect, useState } from 'react';
import { useLogger } from '~Hooks';

export interface ConfirmState {
  onConfirm: ((value: unknown) => void) | null;
  onCancel: (() => void) | null;
  prompt: string;
  isOpen: boolean;
  buttonTexts?: { left: string; right: string };
}

type ConfirmProvider = [ConfirmState, Dispatch<SetStateAction<ConfirmState>>] | [null, null];

export const ConfirmContext = createContext<ConfirmProvider>([null, null]);

interface Props {
  children: React.ReactNode;
}

const ConfirmContextProvider = ({ children }: Props) => {
  const [confirmState, setConfirmState] = useState<ConfirmState>({
    prompt: '',
    isOpen: false,
    onConfirm: null,
    onCancel: null,
  });

  const mountLogger = useLogger('mount');

  useEffect(() => {
    mountLogger.info('Mounted: ConfirmContextProvider');
    return () => {
      mountLogger.info('Unmounted: ConfirmContextProvider');
    };
  }, []);

  return (
    <ConfirmContext.Provider value={[confirmState, setConfirmState]}>
      {children}
    </ConfirmContext.Provider>
  );
};
export default ConfirmContextProvider;
